import React, { Component } from "react";
import { Outlet } from "react-router-dom";
import BackendHeader from "./BackendHeader";
import BackendFooter from "./BackendFooter";
import './assets/all_css_link';
import "./assets/all_js_link"

class BackendLayout extends Component {

  render() {
    return (
      <>
        <BackendHeader />
        <Outlet />
        <BackendFooter />
      </>
    );
  }
  
}

export default BackendLayout;
